import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const ArrowBigRightDash: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M5 9v6' }],
    ['path', { d: 'M9 9h3V5l7 7-7 7v-4H9V9z' }],
  ],
];

export default ArrowBigRightDash;
